import { useLocation } from "react-router-dom";
import Header from "./Header";
import SideBar from "./SideBar";

const Layout = ({ children }) => {
  const location = useLocation();

  const noLayoutRoutes = ["/login", "/forgot-password", "/reset-password"];
  const hideLayout = noLayoutRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      <div className="main-layout" style={{ overflowX: 'hidden', maxWidth: '100vw' }}>
        {!hideLayout && <Header />}
        <main className="main-wrapper w-100 d-flex" style={{ overflowX: 'hidden' }}>
          {!hideLayout && <SideBar />}
          <div className="main-content w-100" style={{ overflowX: 'hidden', minWidth: 0 }}>
            {children}
          </div>
        </main>
      </div>
    </>
  );
};

export default Layout;
